import React, { useMemo } from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import { Moment } from 'moment'
import PageBanner from 'components/Luxkit/Banners/PageBanner'
import useBusinessTravellerBusinessBudgetMapFetcher from 'businessTraveller/hooks/useBusinessTravellerBusinessBudgetMapFetcher'

interface Props {
  checkInDate?: Moment;
  checkOutDate?: Moment;
}

function BusinessTravellerMapBudgetBar(props: Props) {
  const {
    checkInDate,
    checkOutDate,
  } = props
  const numberOfNights = useMemo(() => {
    if (!checkInDate || !checkOutDate) {
      return
    }
    return checkOutDate.diff(checkInDate, 'days')
  }, [checkInDate, checkOutDate])

  const { businessMapBudget } = useBusinessTravellerBusinessBudgetMapFetcher()

  const totalBudget = useMemo(() => (businessMapBudget?.budget ?? 0) * (numberOfNights ?? 0), [businessMapBudget?.budget, numberOfNights])
  const isBudgetBarShown = totalBudget > 0

  if (!isBudgetBarShown) {
    return null
  }

  return <PageBanner
    kind="promotional-primary-accent"
    align="center"
    description={<b>
      Accommodation budget:{' '}
      <FormatCurrency value={totalBudget} format="dynamicDollar" /> total
    </b>}
  />
}

export default BusinessTravellerMapBudgetBar
